export const BRAND_ID_HEADER = 'x-hohr-brand-id';
export const OCP_APIM_SUBSCRIPTION_PARAM = 'subscription-key';
export const X_HOHR_ACT_AS = 'x-hohr-act-as';
export const X_HOHR_CLIENT_VERSION = 'x-hohr-client-version';
export const X_HOHR_CLIENT_PLATFORM = 'x-hohr-client-platform';
export const X_HOHR_UPDATE_NEEDED = 'x-hohr-client-version-update-needed';
export const X_HOHR_NEW_APP_AVAILABLE = 'x-hohr-new-app-available';

export const PHONE_NUMBER_UPDATE = "phonenumber_update";
export const EMAIL_UPDATE = "email_update";
export const PHONE_NUMBER_VERIFICATION = "phonenumber_verification";
export const EMAIL_VERIFICATION = "email_verification";
export const DOCUMENT_SIGN = "document_sign";

export const MAX_DURATION_INPUT_IN_MINUTES = 1439; // Our current implementation only allows max 23h59min due to the Mask we're using
